import { type FC, type PropsWithChildren } from 'react';
import { useUnit } from 'effector-react';
import { Navigate, useLocation } from 'react-router';
import { routes } from '~/shared/constants/routes';
import { $mode } from '~/shared/store/mode';

export const DetectMode: FC<PropsWithChildren> = ({ children }) => {
    const mode = useUnit($mode);
    const { pathname } = useLocation();

    if (pathname === routes.app) {
        return (
            <Navigate
                to={`/${mode}`}
                replace
            />
        );
    }

    return children;
};
